import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { PayrollAccessService } from '../../services/payroll-access/payroll-access.service';

@Injectable({
  providedIn: 'root',
})
export class PayrollAccessGuard {
  constructor(
    private payrollAccessService: PayrollAccessService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const access = await this.payrollAccessService.refresh();
    if (access.canAccessPayrollAdmin) {
      return true;
    }

    return this.router.parseUrl('/');
  }
}
